import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { DataBindingDirective, SelectableSettings, SelectionEvent } from '@progress/kendo-angular-grid';
import { DestroyBase } from 'src/app/components/common/ng-destroy-base';
import { RaciTemplateOverviewModel } from '../../../models/raci-template-model-overview';
import { RaciTemplateService } from '../../../services/raci-template-service';
import { process } from "@progress/kendo-data-query";
import { AppLoadingIndicatorService } from '../../../../../services/app-loading-indicator.service';
import { StringHelper } from '../../../../../components/common/string-helper/string-helper';

/**
 * Handles raci template view component
 */
@Component({
  selector: 'raci-template-view',
  templateUrl: './raci-template-view.component.html',
  styleUrls: ['./raci-template-view.component.css'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RaciTemplateViewComponent extends DestroyBase implements OnInit {
  /**
   *DataBindingDirective
   */
  @ViewChild(DataBindingDirective) dataBinding: DataBindingDirective;

  /**
   * The list of models
   */
  models: RaciTemplateOverviewModel[] = [];

  /**
   * Grid view
   */
  public gridView: RaciTemplateOverviewModel[];

  /**
   * Search active?
   */
  searchActive = false;

  /**
   * Selectable settings
   */
  public selectableSettings: SelectableSettings = {
    checkboxOnly: false,
    mode: 'single',
    drag: false,
  };

  /**
   * Selected IDs
   */
  public selectedIds: number[] = [];

  /**
   * Constructor
   * @param cmService CalculationModelService
   * @param ref ChangeDetectorRef
   */
  constructor(private rtService: RaciTemplateService,
    private ref: ChangeDetectorRef,
    private appLoadingIndicator: AppLoadingIndicatorService) {
    super();
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.appLoadingIndicator.show();

    setTimeout(() => {
      this.rtService.triggerSelectedId(0);
    })

    this.subscriptions.add(this.rtService.getTemplates().subscribe(data => {
      this.gridView = data;
      this.models = data;
      this.appLoadingIndicator.hide();
      this.ref.markForCheck();
    }));

    this.subscriptions.add(this.rtService.searchActive$.subscribe(active => {
      this.searchActive = active;
      this.ref.markForCheck();
    }));

    setTimeout(() => {
      this.rtService.setDisableEdit(true);
    })
  }

  /**
 * Called on model selection
 * @param e Selection event
 */
  onSelect(e: SelectionEvent) {
    if (e.selectedRows.length > 0) {
      const item = e.selectedRows[0].dataItem;
      this.rtService.setSelectedTemplate(item);
      this.rtService.setDisableEdit(item.oid == 0);
    }
  }

  /**
   * Search
   * @param filters Search filters
   */
  search(filters: RaciTemplateOverviewModel) {
    const filter = [];
    if (!StringHelper.isNullOrEmpty(filters.name)) {
      filter.push({
        field: "name",
        operator: "contains",
        value: filters.name,
      })
    }
    this.gridView = process(this.models, {
      filter: {
        logic: "and",
        filters: filter,
      },
    }).data;
  }

  /**
  * Get status description
  * @param id Status id
  */
  getStatus(id: number): string {
    return this.rtService.getTemplateStatusById(id);
  }
}
